// extracted by mini-css-extract-plugin
export default {"dropzone":"Dropzone_dropzone__FHT6C"};